import { RequestError, RequestErrorType } from './models/Error';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Collection of tools
 */
export class Tools {
  /**
   * Checks which kind of error the given error is.
   * @param {HttpErrorResponse} error Error
   * @returns {RequestError} Error with error type (clientside or serverside)
   */
  static checkError(error: HttpErrorResponse): RequestError {
    return {
      type: error.error instanceof Error ? RequestErrorType.CLIENTSIDE : RequestErrorType.SERVERSIDE,
      body: error,
    };
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/tools.ts